import React, { useRef } from 'react'
import { KeepAlive, useActivate, useUnactivate } from 'react-activation'

// hack：affix位置问题
const ActivateHook = ({ name, getManager, children }) => {
    const elRef = useRef(null)

    useActivate(() => {
        if (getManager) {
            const manager = getManager()

            // 还原滚动位置
            manager && manager.restoreScrollPosition(name)
        }

        setTimeout(() => {
            if (elRef.current) {
                elRef.current.classList.remove('hide-affix')
            }
        }, 0)
    })

    useUnactivate(() => {
        if (elRef.current) {
            elRef.current.classList.add('hide-affix')
        }
    })

    return <div ref={elRef}>{children}</div>
}

const isRoute = cp => {
    return cp?.type?.displayName === 'Route'
}

const isSwitch = cp => {
    return cp?.type?.displayName === 'Switch'
}

// dynamicImport 容器名
const isLoadableComponent = cp => {
    return cp?.type?.displayName === 'LoadableComponent'
}

// umi构建routes时，创建微应用的component名为"RouteComponent"
// 这里直接使用名称判断，暂时没啥问题，一般人也不会将页面组件名称定义为这个
const isMicroAppRouteComponent = cp => {
    return false
}

// 包裹keepAlive后，路由信息上下文出现问题，路由参数变更，页面没有更新，这里使用withRouter连接一下
// 貌似升级不需要了
// const WrapRoute = withRouter(({ children, ...restProps }) => {
//     return React.cloneElement(children, restProps)
// })

// 路由缓存方案，在布局组件中处理
// 注意：需要将KeepAlive包裹在页面组件那一层，不能包在路由组件外
const KeepAliveChildren = ({ children, getManager }) => {
    if (!children) {
        return children
    }

    // 微应用
    if (isMicroAppRouteComponent(children)) {
        if (!children?.props?.route?.keepalive) {
            return children
        }

        return <KeepAlive name={children.props.route.name}>{children}</KeepAlive>
    }

    const newChildren = React.Children.map(children.props.children, child => {
        // Switch
        if (isSwitch(child)) {
            return <KeepAliveChildren getManager={getManager}>{child}</KeepAliveChildren>
        }

        // Route
        if (isRoute(child)) {
            if (typeof child?.props?.render === 'function') {
                const rawRender = child.props.render

                // 修改Route的render方法
                return React.cloneElement(child, {
                    render(props) {
                        const res = rawRender(props)

                        return <KeepAliveChildren getManager={getManager}>{res}</KeepAliveChildren>
                    }
                })
            }
        }

        return child
    })

    // dynamicImport
    if (isLoadableComponent(children)) {
        const rawRender = children.type.render

        children.type.render = (...args) => {
            const res = rawRender(...args)

            if (!res?.props?.route?.keepalive) {
                return res
            }

            if (res?.props?.route && res?.props?.route?.name) {
                return (
                    <KeepAlive name={res.props.route.name}>
                        <ActivateHook name={res.props.route.name} getManager={getManager}>
                            {res}
                        </ActivateHook>
                    </KeepAlive>
                )
            }

            return res
        }
    }

    return React.cloneElement(children, {
        children: newChildren
    })
}

export default KeepAliveChildren
